import { useFormContext, useWatch } from 'react-hook-form';

import { useStoreDispatch } from '@libs/common-next';

import { DeliveryMethodType, useProduct } from '@/entities/product';
import type { FormFields } from '@/entities/purchase-form';
import { type StoreDrawerOptions, useStoreDrawer } from '@/features/store-drawer';

export const useBopisDeliveryStatus = () => {
    const { updateSelectedStore } = useStoreDispatch();
    const { product, tailored, isLoading, isError } = useProduct();
    const { control } = useFormContext<FormFields>();
    const open = useStoreDrawer();

    const deliveryMethod = useWatch({ control, name: 'fulfilmentMethod' });
    const uppercaseDeliveryMethod = deliveryMethod.toUpperCase() as DeliveryMethodType;

    const storeId = product?.sku && tailored?.variants?.[product.sku].BOPIS?.storeId;

    function openStoreDrawer(props: Omit<StoreDrawerOptions, 'sku' | 'minPurchaseQuantity'>) {
        return open({
            ...props,
            sku: product?.sku,
            minPurchaseQuantity: product?.deliveryMethods[uppercaseDeliveryMethod].purchaseQuantities?.min || 0,
        });
    }

    return {
        isError,
        isLoading,
        isLivePetInStoreOnly: product?.isLivePetInStoreOnly,
        storeDetails: storeId ? tailored?.bopisStoreData?.[storeId]?.storeDetails : null,
        availableStock: product?.sku ? (tailored?.variants?.[product.sku].BOPIS?.availableStock ?? 0) : 0,
        isCurbsideAvailable: !!storeId && tailored?.bopisStoreData?.[storeId]?.offersCurbsidePickup,
        minimumCaseQty: product?.deliveryMethods?.BOPIS?.purchaseQuantities?.min ?? 1,
        openStoreDrawer,
        updateSelectedStore,
    };
};
